import { Theme } from './Theme';
import { Config as TwilioConfig } from '@twilio/flex-webchat-ui/src/state/AppConfig';
import { ConfigProps } from '../../../types/webChat.type';

export const Config = (config: ConfigProps, isDisabled = false): TwilioConfig => ({
    available: !isDisabled,
    accountSid: config.flexAccountSid,
    flexFlowSid: config.flexFlowSid,
    colorTheme: {
        overrides: Theme(config.theme),
    },
    context: {
        ...config.user,
    },
    markdownSupport: {
        enabled: true,
    },
    fileAttachment: {
        enabled: true,
    },
});
